export default {
  Group: 0, // nhóm
  SubGroup: 1, // tiểu nhóm
  Item: 2, // mục
  SubItem: 3, // tiểu mục
  SubSection: 4, // tiết tiểu mục
};
